import { render } from "./SideNavbarForMediumComponent.vue?vue&type=template&id=28fec0be&scoped=true"
import script from "./SideNavbarForMediumComponent.vue?vue&type=script&lang=js"
export * from "./SideNavbarForMediumComponent.vue?vue&type=script&lang=js"

import "./SideNavbarForMediumComponent.vue?vue&type=style&index=0&id=28fec0be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fec0be"]])

export default __exports__